export default function () {
  const swiper = this;
  const { $wrapperEl, params, slides } = swiper;
  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
  slides.removeAttr('data-swiper-slide-index');
}



// WEBPACK FOOTER //
// ./node_modules/framework7/components/swiper/swiper-class/components/core/loop/loopDestroy.js